import React from 'react';
import { Routes, Route } from 'react-router-dom';
import DoctorsPage from './components/DoctorsPage';
import Doctor from './components/Doctos';
import GlobalPresence from './components/GlobalPresence';
import Blogs from './components/Blogs';
import Blog1 from './components/Blog1';
import Blog2 from './components/Blog2';
import Blog3 from './components/Blog3';
import Blog4 from './components/Blog4';
import Blog5 from './components/Blog5';
import Products from './components/Products';
import DietarySupplements from './components/DietarySupplements';
import SyrupsAndSuspensions from './components/SyrupsAndSuspensions';
import EffervescentTablets from './components/EffervescentTablets';
import FitnessSupplementsTablets from './components/FitnessSupplementsTablets';
import FitnessSupplementsPowders from './components/FitnessSupplementsPowders';
import HealthcareProteinSupplements from './components/HealthcareProteinSupplements';
import EnergyDrinkAndSachets from './components/EnergyDrinkAndSachets';
import SoftgelSupplements from './components/SoftgelSupplements';
import SkinAndHairSupplements from './components/SkinAndHairSupplements';
import EnergyDrinkAndSticks from './components/EnergyDrinkAndSticks';
import OtherNutraceuticalProducts from './components/OtherNutraceuticalProducts';
import Cosmetics from './components/Cosmetics';
import Gummies from './components/Gummies';
import Herbals from './components/Herbals';

function App() {
  return (
    <Routes>
      <Route path="/home" element={<Doctor />} />
      <Route path="/" element={<Doctor />} /> {/* Temporary route for testing */}
      <Route path="/global-presence" element={<GlobalPresence />} />
      <Route path="/blogs" element={<Blogs />} />
      <Route path="/the-rise-of-nutraceuticals" element={<Blog1 />} />
      <Route path="/the-benefits-of-nutraceuticals" element={<Blog2 />} />
      <Route path="/the-importance-of-nutraceuticals" element={<Blog3 />} />
      <Route path="/the-future-of-nutraceuticals" element={<Blog4 />} />
      <Route path="/the-importance-of-nutraceuticals" element={<Blog5 />} />
      <Route path="/products" element={<Products />} />
      <Route path="/dietary-supplements" element={<DietarySupplements />} />
      <Route path="/syrups-and-suspensions" element={<SyrupsAndSuspensions />} />
      <Route path="/effervescent-tablets" element={<EffervescentTablets />} />
      <Route path="/fitness-supplements-tablets" element={<FitnessSupplementsTablets />} />
      <Route path="/fitness-supplements-powders" element={<FitnessSupplementsPowders />} />
      <Route path="/healthcare-protein-supplements" element={<HealthcareProteinSupplements />} />
      <Route path="/energy-drink-and-sachets" element={<EnergyDrinkAndSachets />} />
      <Route path="/softgel-supplements" element={<SoftgelSupplements />} />
      <Route path="/skin-and-hair-supplements" element={<SkinAndHairSupplements />} />
      <Route path="/energy-drink-and-sticks" element={<EnergyDrinkAndSticks />} />
      <Route path="/other-nutraceutical-products" element={<OtherNutraceuticalProducts />} />
      <Route path="/cosmetics" element={<Cosmetics />} />
      <Route path="/gummies" element={<Gummies />} />
      <Route path="/herbals" element={<Herbals />} />
    </Routes>
  );
}

export default App;
